import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { ssnUI } from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info-title--id'];
const INPUT_LABEL = content['vet-input-label'];

const { ssn } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    veteranSsnOrTin: ssnUI({ label: INPUT_LABEL, type: 'ssn' }),
  },
  schema: {
    type: 'object',
    required: ['veteranSsnOrTin'],
    properties: {
      veteranSsnOrTin: ssn,
    },
  },
};
